import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=7966b4ce&scoped=true"
import script from "./DataViewer.vue?vue&type=script&lang=ts"
export * from "./DataViewer.vue?vue&type=script&lang=ts"
import style0 from "./DataViewer.vue?vue&type=style&index=0&id=7966b4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7966b4ce",
  null
  
)

/* custom blocks */
import block0 from "./DataViewer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports